function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_469",
  "data-name": "Path 469",
  d: "M33.52-347.74a.654.654,0,0,1,.477.206.654.654,0,0,1,.176.488l-1.014,16.353a2.428,2.428,0,0,1-2.424,2.278H15.918a2.428,2.428,0,0,1-2.424-2.278s-.816-13.154-1.014-16.353a.654.654,0,0,1,.176-.488.654.654,0,0,1,.477-.206Zm-11.831,9.668-2.64-2.641a1.171,1.171,0,0,1,0-1.655,1.171,1.171,0,0,1,1.655,0l2.64,2.64,2.625-2.625a1.171,1.171,0,0,1,1.655,0,1.171,1.171,0,0,1,0,1.655L25-338.072l2.625,2.625a1.171,1.171,0,0,1,0,1.655,1.171,1.171,0,0,1-1.655,0l-2.625-2.625-2.64,2.64a1.171,1.171,0,0,1-1.655,0,1.171,1.171,0,0,1,0-1.655Z",
  transform: "translate(-11.301 356.285)",
  fill: "#bc3535",
  fillRule: "evenodd"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_470",
  "data-name": "Path 470",
  d: "M15.66-354.145v-1.119a3.788,3.788,0,0,1,1.11-2.678,3.79,3.79,0,0,1,2.679-1.11H26.39a3.79,3.79,0,0,1,2.679,1.11,3.788,3.788,0,0,1,1.11,2.678v1.119h3.573a1.169,1.169,0,0,1,1.168,1.168,1.169,1.169,0,0,1-1.168,1.169H12.087a1.169,1.169,0,0,1-1.168-1.169,1.169,1.169,0,0,1,1.168-1.168Zm12.056,0v-1.208a1.283,1.283,0,0,0-.375-.907,1.283,1.283,0,0,0-.906-.375H19.317a1.283,1.283,0,0,0-.907.375,1.283,1.283,0,0,0-.375.907v1.208Z",
  transform: "translate(-10.919 359.053)",
  fill: "#bc3535",
  fillRule: "evenodd"
});

var SvgDelete = function SvgDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_898",
    "data-name": "Group 898",
    width: 24,
    height: 27.871,
    viewBox: "0 0 24 27.871",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete.55e463cf.svg";
export { ForwardRef as ReactComponent };